import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const COLORS = ["#3b82f6", "#22c55e", "#f59e0b", "#ef4444", "#8b5cf6"];

function ProfitDonutChart() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const user      = JSON.parse(localStorage.getItem("user") || "{}");
      const companyId = user?.company_id || "";
      if (!companyId) return;

      // ✅ company_id filter added
      const projectSnap = await getDocs(
        query(collection(db, "projects"), where("company_id", "==", companyId))
      );
      const projectMap = {};
      projectSnap.forEach((doc) => {
        projectMap[doc.id] = doc.data().project_name;
      });

      // ✅ company_id filter added
      const txnSnap = await getDocs(
        query(collection(db, "financial_transactions"), where("company_id", "==", companyId))
      );

      const projectProfit = {};
      txnSnap.forEach((doc) => {
        const d = doc.data();
        const projectId = d.project_id;
        if (!projectProfit[projectId]) projectProfit[projectId] = 0;
        if (d.type === "income")  projectProfit[projectId] += d.amount || 0;
        if (d.type === "expense") projectProfit[projectId] -= d.amount || 0;
      });

      const finalData = Object.keys(projectProfit).map((pid) => ({
        name:  projectMap[pid] || "Unknown",
        value: Math.abs(projectProfit[pid]),
      }));

      setData(finalData);
    };

    fetchData();
  }, []);

  const total = data.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="flex items-center h-[280px]">
      <div className="w-1/2 h-full flex justify-center items-center">
        <ResponsiveContainer width={260} height={260}>
          <PieChart>
            <Pie data={data} dataKey="value" cx="50%" cy="50%" innerRadius={70} outerRadius={100} paddingAngle={3}>
              {data.map((entry, index) => (
                <Cell key={index} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 18, fontWeight: 600 }}>
              ₹{total.toLocaleString()}
            </text>
            <text x="50%" y="50%" dy={20} textAnchor="middle" dominantBaseline="middle" style={{ fontSize: 12, fill: "#6b7280" }}>
              Total Profit
            </text>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="w-1/2 flex flex-col justify-center gap-4 pl-4">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }} />
              <span className="text-sm text-gray-700">{item.name}</span>
            </div>
            <span className="text-sm font-medium text-gray-800">₹{item.value.toLocaleString()}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProfitDonutChart;